import { useUser } from '~hooks'

const CreditMessage = () => {
  const [user, { loading }] = useUser()

  if (loading && !user) return <div className="placeholder h-[7rem]" />

  if (!loading && !user) return null

  return (
    <div className="widget p-4 flex space-x-4">
      <div>
        <div
          className="text-2xl uppercase mb-2 glow-text-primary tracking-widest"
          color="g-green-darker"
        >
          Granted rewards
        </div>
        <div className="text-g-light-gray text-sm">
          Finish setting up your account to earn more rewards!
        </div>
      </div>

      <div>
        <div className="uppercase text-xs whitespace-nowrap text-g-light-gray mb-2 text-end">
          Your Balance
        </div>
        <div className="uppercase text-[3rem] leading-none glow-text-primary text-end">
          ${user.credit}
        </div>
      </div>
    </div>
  )
}
export default CreditMessage
